import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IRIFormProps } from '../../../_core/form/form.types';

interface IUpdateLocationFormValues {
  name: string;
}

interface IUpdateLocationFormProps extends IRIFormProps<IUpdateLocationFormValues> {
  name: string;
}

export const UpdateLocationForm = ({ name, onSubmit }: IUpdateLocationFormProps) => {
  const validateForm = (values: IUpdateLocationFormValues) => {
    const errors: FormikErrors<IUpdateLocationFormValues> = {};

    if (!values.name.trim()) {
      errors.name = 'Required';
    }

    return errors;
  };

  return (
    <Formik
      initialValues={{ name } as IUpdateLocationFormValues}
      onSubmit={(values) => onSubmit({ name: values.name.trim() })}
      validate={validateForm}
    >
      {(props: FormikProps<IUpdateLocationFormValues>) => (
        <Form action="#" method="POST" className="sm:max-w-xl mx-auto space-y-4 mt-10">
          <FormInputWithLabel name="name" label="Name" placeholder="Edit location name" />
          <FormButton loading={props.isSubmitting} text="Update" />
        </Form>
      )}
    </Formik>
  );
};
